export default "__VITE_ASSET__DrGbgx$l__"